import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import Logotype from '../../images/logotype.png';
import UiCounter from '../Ui/Counter/Counter';
import './Header.scss';
import { BROWSE, navigationMapping } from '../../consts/navigation';
import { connect } from 'react-redux';
import { TOGGLE_MENU } from '../../redux/Layout';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import LogoMenu from './LogoMenu';

const Header = ({
  t,
  avatarThumb,
  newConversationsCount,
  isLoading,
  isMobile,
  toggleMenu,
  userData,
}) => {
  const [logoMenuOpen, setLogoMenuOpen] = useState(false)
  return (
    <header className="row dealers-header">
      {logoMenuOpen &&
        <LogoMenu avatarThumb={avatarThumb} setLogoMenuOpen={setLogoMenuOpen} />
      }
      <div className="col-md-2 dealers-header__logotype-area">
        {!isMobile &&
          <Link to={navigationMapping[BROWSE].table_url} className="dealers-header__logotype-area__logo">
            <img src={Logotype} className="logotype" alt="Estimoto" />
          </Link>
        }

        {isMobile &&
          <div className="col-md-10 right-column login__area" onClick={() => setLogoMenuOpen(true)}>
            {isLoading && (
              <span className="header-processing">
                {t('processing')}<span>.</span><span>.</span><span>.</span>
              </span>
            )}

            <img src={avatarThumb} alt="User name" className="login__area-avatar" />
          </div>
        }

        {isMobile && (
          <div className="dealers-header__logotype-area__menu-wrapper" onClick={toggleMenu}>
            <i className="material-icons header-menu-icon hidden-lg hidden-md">menu</i>
            { newConversationsCount > 0 && <UiCounter count={newConversationsCount} onMenu={true} /> }
          </div>
        )}
      </div>

      {!isMobile && (
        <div dataTestId="ChangeVehicleType" className="col-md-10 right-column login__area" onClick={() => setLogoMenuOpen(true)}>
          {isLoading && (
            <span className="header-processing">
              {t('processing')}<span>.</span><span>.</span><span>.</span>
            </span>
          )}

          <img src={avatarThumb} alt="User name" className="login__area-avatar" />
          <span className="login__area-name">{get(userData, 'first_name')}</span>
        </div>
      )}
    </header>
  )
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  avatarThumb: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  newConversationsCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  toggleMenu: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
};

Header.defaultProps = {
  conversationsIconLabel: '',
  isLoading: false,
  isMobile: true,
};

const mapStateToProps = (state) => {
  return {
    userData: get(state, 'userData'),
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleMenu: () => dispatch(TOGGLE_MENU()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('header')
)(Header);
